const Plugin = {}

Plugin.install = function install (Vue) {
    if (install.installed) return;
    install.installed = true;

    Vue.mixin({
        data: () =>({
            app_version: process.env.VUE_APP_VERSION || '0',
            app_refreshing: false,
            app_registration: null,
            app_update_exists: false,
        }),
        mounted: function () {
            document.addEventListener('swUpdated', this.appUpdateAvailable, { once: true })
            if(navigator.serviceWorker) {
                navigator.serviceWorker.addEventListener('controllerchange', () => {
                    if (this.app_refreshing) return
                    this.app_refreshing = true
                    // Here the actual reload of the page occurs
                    window.location.reload()
                })
            }
        },
        methods: {
            // Store the SW registration so we can send it a message
            // We use `app_update_exists` to control whatever alert, toast, dialog, etc we want to use
            // To alert the user there is an update they need to refresh for
            appUpdateAvailable(event) {
                this.app_registration = event.detail
                this.app_update_exists = true
            },
            // Called when the user accepts the update
            appRefresh() {
                this.app_update_exists = false
                // Make sure we only send a 'skip waiting' message if the SW is waiting
                if (!this.app_registration || !this.app_registration.waiting) return
                // send message to SW to skip the waiting and activate the new SW
                this.app_registration.waiting.postMessage({ type: 'SKIP_WAITING' })
            },
        }
    })
}

export default Plugin

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Plugin)
}
